module.exports = __webpack_public_path__ + "img/alcaldia-logo-texto.fbbd2dce.png";